import { Api, Auth } from '~/services';
import { getArticlesFeed as _getArticlesFeed } from '../api/articles';

export const getArticlesFeed = () => {
	return ( dispatch, getStore ) => {
		return dispatch(
			async dispatch => {

				dispatch({
					type: 'REQUEST_ARTICLES'
				})
				dispatch({
					type: 'REQUEST_WORKSHOPS'
				})

				const params = Auth.loggedIn() ? { secure_token: Auth.getToken() } : {};

				const data = await _getArticlesFeed(params);

                dispatch({
                    type: 'RECEIVE_ARTICLES',
                    articles: data.articles
                })
                dispatch({
                    type: 'RECEIVE_WORKSHOPS',
                    workshops: data.workshops
                })
			}
		)
	}
}


export const refreshArticlesFeed = () => {
	return ( dispatch, getStore ) => {
		return dispatch(
			dispatch => {
				dispatch({
					type: 'REFRESH_ARTICLES'
				})
			}
		)
	}
}


export const toggleArticleFlare = ( id ) => {

	return ( dispatch, getStore ) => {

		if( !Auth.loggedIn() ) return;

		Api.post( '/wp/article/' + id + '/flare', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( ! data || error ) {
				return;
			}
			dispatch({
				type: 'RECEIVE_ARTICLES_SINGLE',
				article: data
			})
		})
	}
	
}



// WEBPACK FOOTER //
// ./src/js/actions/articles.js